module.exports = __webpack_public_path__ + "static/ppt02-8050d11da7e437b4f20e319df9c35282.png";